import React from 'react';
import { TrackImpression } from '@udemy/event-tracking';
import { useI18n } from '@udemy/i18n';
import { Icon } from '@udemy/icons';
import { toBusinessUdemy } from '@udemy/organization';
import { Button } from '@udemy/react-core-components';
import { useUDData } from '@udemy/ud-data';
import { trackSubscriptionLearnMoreEvent, trackSubscriptionOfferImpressionEvent, trackUFBNoticeClickEvent, trackUFBNoticeImpressionEvent } from '../../../events';
import styles from "./plans-and-pricing-buttons.module.css";
export const PlanButton = ({
  Icon,
  primaryText,
  href,
  secondaryText,
  onClick,
  onPresented,
  dataTestId,
  openInNewTab
}) => {
  return /*#__PURE__*/React.createElement(TrackImpression, {
    trackFunc: onPresented
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    className: styles['plan-button'],
    "data-testid": dataTestId,
    href: href,
    udStyle: "secondary",
    size: "large",
    onClick: onClick,
    componentClass: "a",
    target: openInNewTab ? '_blank' : undefined,
    rel: openInNewTab ? 'noopener' : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['button-content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['button-column']
  }, Icon), /*#__PURE__*/React.createElement("div", {
    className: styles['button-column']
  }, /*#__PURE__*/React.createElement("span", {
    className: styles['button-headline-text']
  }, primaryText), /*#__PURE__*/React.createElement("span", {
    className: styles['button-secondary-text']
  }, secondaryText))))));
};
const uiRegion = 'plans_and_pricing_dropdown';
export const PersonalPlanButton = () => {
  const {
    gettext
  } = useI18n();
  const icon = /*#__PURE__*/React.createElement(Icon, {
    glyph: "person",
    label: false,
    color: "subdued",
    size: "large"
  });
  const primaryText = gettext('Personal Plan');
  const secondaryText = gettext('Only you');
  const href = '/personal-plan';
  const dataTestId = 'personal-plan-button';
  const personalPlanOnPresented = () => {
    trackSubscriptionOfferImpressionEvent(uiRegion);
  };
  const personalPlanOnClick = () => {
    trackSubscriptionLearnMoreEvent(uiRegion);
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlanButton, {
    Icon: icon,
    primaryText: primaryText,
    secondaryText: secondaryText,
    href: href,
    onClick: personalPlanOnClick,
    onPresented: personalPlanOnPresented,
    dataTestId: dataTestId,
    openInNewTab: false
  }));
};
export const BusinessPlansButton = () => {
  const {
    gettext
  } = useI18n();
  const {
    request: udRequest
  } = useUDData();
  const icon = /*#__PURE__*/React.createElement(Icon, {
    glyph: "people",
    label: false,
    color: "subdued",
    size: "large"
  });
  const primaryText = gettext('Business Plans');
  const secondaryText = gettext('2 or more people');
  const dataTestId = 'business-plans-button';
  const ubHref = toBusinessUdemy('plans', {
    ref: uiRegion
  });
  const businessPlanOnPresented = (udRequest, ubHref) => {
    trackUFBNoticeImpressionEvent(udRequest, uiRegion, ubHref);
  };
  const businessPlanOnClick = () => {
    trackUFBNoticeClickEvent(udRequest, uiRegion, ubHref);
  };
  const onPresented = () => businessPlanOnPresented(udRequest, ubHref);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlanButton, {
    Icon: icon,
    primaryText: primaryText,
    secondaryText: secondaryText,
    href: ubHref,
    onClick: businessPlanOnClick,
    onPresented: onPresented,
    dataTestId: dataTestId,
    openInNewTab: true
  }));
};
//# sourceMappingURL=plans-and-pricing-buttons.react-component.js.map